<script>
  import { navigate } from 'svelte-routing';
  import { authStore } from '../authStore';
  import { login } from '../authService';
  import { getApiUrl } from '../api';

  let code = '';
  let error = '';
  let isLoading = false;
  let currentUser = null;

  authStore.subscribe(val => currentUser = val.user);

  async function handleClaim() {
    if (!currentUser) {
        // If not logged in, prompt login flow
        login(); 
        return;
    }

    isLoading = true;
    error = '';

    try {
        const res = await fetch(getApiUrl('/premises/claim'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId: currentUser.idTokenClaims.oid, invitationCode: code })
        });
        
        const data = await res.json();
        if (!res.ok) throw new Error(data.error);

        alert("Success! You have claimed this store.");
        navigate('/business-profile'); // Redirect to new business profile
        
    } catch(e) {
        error = e.message;
    } finally {
        isLoading = false;
    }
  }
</script>

<div class="claim-container">
    <h1>Claim Your Business</h1>
    <p>Enter the 6-digit invitation code found on your card to take ownership of your store listing.</p>
    
    <input type="text" bind:value={code} placeholder="123456" maxlength="6" class="code-input" />
    
    <button on:click={handleClaim} disabled={isLoading}>
        {currentUser ? 'Claim Store' : 'Log In to Claim'}
    </button>

    {#if error}
        <p class="error">{error}</p>
    {/if}
</div>

<style>
    .claim-container { max-width: 500px; margin: 4rem auto; text-align: center; padding: 2rem; background: white; border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.1); }
    .code-input { font-size: 2rem; letter-spacing: 0.5rem; text-align: center; width: 200px; margin: 2rem auto; display: block; padding: 0.5rem; }
    button { background-color: #007bff; color: white; font-size: 1.2rem; padding: 1rem 2rem; border: none; border-radius: 4px; cursor: pointer; width: 100%; }
    .error { color: red; margin-top: 1rem; }
</style>